import { render, staticRenderFns } from "./PopoverMethod.vue?vue&type=template&id=0fae7afd"
import script from "./PopoverMethod.vue?vue&type=script&lang=js"
export * from "./PopoverMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports